import "@/App.css";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { CaseStudyZime } from "@/components/CaseStudyZime";
import { CaseStudyZoftware } from "@/components/CaseStudyZoftware";
import { Experience } from "@/components/Experience";
import { SideProjects } from "@/components/SideProjects";
import { Capabilities } from "@/components/Capabilities";
import { Philosophy } from "@/components/Philosophy";
import { Contact } from "@/components/Contact";
import { motion } from "framer-motion";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#EDEDED] relative">
      <div className="noise-overlay" />

      <Navigation />

      <main className="relative z-10">
        <Hero />

        <div className="section-divider" />
        <About />

        <div className="section-divider" />

        {/* Selected Work Section */}
        <section id="work" data-testid="selected-work-section" className="py-16 sm:py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="mb-14"
            >
              <span className="inline-block text-xs font-mono text-[#38bdf8] tracking-wider uppercase mb-4">
                Selected Work
              </span>
              <h2
                data-testid="selected-work-heading"
                className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#EDEDED] tracking-tight"
              >
                Product systems I've built.
              </h2>
            </motion.div>

            <CaseStudyZime />

            <div className="section-divider my-12" />

            <CaseStudyZoftware />
          </div>
        </section>

        <div className="section-divider" />
        <Experience />

        <div className="section-divider" />
        <SideProjects />

        <div className="section-divider" />
        <Capabilities />

        <div className="section-divider" />
        <Philosophy />

        <div className="section-divider" />
        <Contact />
      </main>
    </div>
  );
}

export default App;
